import {LogicDependentReferenceDto} from "./logic-dependent-reference.dto";

/**
 * Result of an LG dependency analysis — 'where is this entity used?'.
 *
 * Endpoints: `/mvsa/lg/dependencies/logic/{id}`, `/flow/{id}`, `/mapping-table/{id}`.
 */
export interface LogicDependencyResultDto {

    /** The referencing entities found. Empty means 'no TYPED reference' — see the coverage note below. */
    dependents?: LogicDependentReferenceDto[];
}

/**
 * The coverage limit of the mapping-table dependency analysis, in German, for display next to the
 * result list.
 *
 * The backend finds a mapping table only through a typed foreign key: `LogicFlowStep.mappingTable` and
 * `Logic.mappingTable`. Two further ways to reach the very same table are invisible and always will be
 * — `$ctx.lookupMapping(alias, ...)` inside Groovy/SpEL script bodies, and direct Java calls to
 * `LogicMappingService#lookupValue(alias, ...)` from the persist providers in `ci` / `cm` / `cw`. Both
 * name the table by an alias STRING, one of them in compiled code.
 *
 * An empty result therefore means 'no typed reference', NEVER 'nothing depends on this table'. The
 * backend sends no flag for this — it is a property of the query, not of any one result — so any
 * surface that turns the list into a decision has to render this note itself. Leaving it out turns an
 * incomplete search into a false all-clear.
 */
export const LG_MAPPING_TABLE_DEPENDENCY_COVERAGE_NOTE: string =
    'Diese Liste zeigt nur Referenzen über einen echten Fremdschlüssel (Flow-Schritte und ' +
    'Mapping-Logiken). Aufrufe aus Skripten ($ctx.lookupMapping) und aus Java-Code sind hier ' +
    'grundsätzlich nicht sichtbar — eine leere Liste bedeutet daher nicht, dass die Tabelle ' +
    'unbenutzt ist.';
